module.exports = __webpack_public_path__ + "static/media/reject.ba4df928.svg";